let ssrFailedMarker = false;

/**
 * @internal only for local usage by rendering guard
 */
export const markSSRFailure = () => {
	ssrFailedMarker = true;
};

/**
 * reports if SSR failure was reported via ReportSSRFailOnUse
 */
export const hasFailedSSR = () => ssrFailedMarker;
